// extracted by mini-css-extract-plugin
export default {"loginPageContainer":"style_loginPageContainer__QPBKX","loginPageContainer_content":"style_loginPageContainer_content__vFmW8"};